import { DefaultState } from '@src/redux/types'

import { RESERVATION_ROOM_ALL, RESERVATION_ROOM_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [RESERVATION_ROOM_LIST]: DefaultState<`${typeof API.RESERVATION_ROOM}`, 'get'>
  [RESERVATION_ROOM_ALL]: DefaultState<`${typeof API.RESERVATION_ROOM_ALL}`, 'get'>
} = () => ({
  [RESERVATION_ROOM_LIST]: defaultState(),
  [RESERVATION_ROOM_ALL]: defaultState(),
})
